export interface ApiRequestMeta {
    Total?: number;
    Filter?: any;
}

/**
 * Client-side state wrapper for API request lifecycle.
 * Mirrors the backend ApiResponse shape and adds loading/error tracking.
 * PascalCase to match backend JSON serialization conventions.
 */
export interface ApiRequest<T = any> {
    IsLoading: boolean;
    IsSuccess: boolean;
    IsError: boolean;
    Data: T | null;
    Message: string | null;
    Errors: string[] | null;
    Redirect: string | null;
    Meta: ApiRequestMeta | null;
}

/**
 * Creates a fresh, idle ApiRequest state object.
 */
export function createApiRequest<T = any>(): ApiRequest<T> {
    return {
        IsLoading: false,
        IsSuccess: false,
        IsError: false,
        Data: null,
        Message: null,
        Errors: null,
        Redirect: null,
        Meta: null,
    };
}

/**
 * Maps a raw server ApiResponse into an ApiRequest state object.
 */
export function mapApiResponse<T = any>(response: any): Partial<ApiRequest<T>> {
    const success = response?.Success === true || response?.Status === 1;
    return {
        IsLoading: false,
        IsSuccess: success,
        IsError: !success,
        Data: response?.Data ?? null,
        Message: response?.Message ?? null,
        Errors: response?.Errors ?? null,
        Redirect: response?.Redirect ?? null,
        Meta: response?.Meta ?? null,
    };
}
